import React, { useEffect, useState } from 'react';
import { Button } from '@own/fds-react';
import { useParams } from 'react-router-dom';
import './dyf-more-ways-to-learn-card.scss';
import { useMoreWaysToLearn } from './use-more-ways-to-learn';
import { getVehicleDataSelector } from '../../../../services/content-service/content-service-util';
import { MoreWaysToLearnView } from './dyf-more-ways-to-learn';

interface Props {
    vehicleYmmGroup: any;
    renderView: MoreWaysToLearnView;
    baseRoot: string;
    fullRenderHTV: boolean;
}

const renderMap = {
    'related-articles': 'more-ways-to-learn-related-articles',
    'article-overview': 'more-ways-to-learn',
};
export const DyfMoreWaysToLearnTitle = (props: Props) => {
    const moreWaysToLearnComponent = useMoreWaysToLearn(
        'vehicle-data',
        getVehicleDataSelector(
            renderMap[props.renderView],
            props.vehicleYmmGroup
        ),
        'morewaystolearn',
        true
    );
    return <>{moreWaysToLearnComponent?.title}</>;
};
export const DyfMoreWaysToLearnCards = (props: Props) => {
    const { vin = '', category = '', title = '' } = useParams<{
        vin: string;
        category?: string;
        title: string;
    }>();
    const moreWaysToLearnComponent = useMoreWaysToLearn(
        'vehicle-data',
        getVehicleDataSelector(
            renderMap[props.renderView],
            props.vehicleYmmGroup
        ),
        'morewaystolearn',
        true
    );
    const modifyCardCtaUrl = (str: string) => {
        if (str.includes('/[title]/related-articles')) {
            return category === ''
                ? str.replace('[vin]', vin).replace('[title]', title)
                : str
                      .replace('[vin]', vin)
                      .replace('/[title]/', '')
                      .replace('related-articles', '') +
                      `/${category}/${title}/related-articles`;
        }
        if (str.includes('/[title]/overview')) {
            return category === ''
                ? str.replace('[vin]', vin).replace('[title]', title)
                : str
                      .replace('[vin]', vin)
                      .replace('/[title]/', '')
                      .replace('overview', '') +
                      `/${category}/${title}/overview`;
        }
        return str;
    };

    const [cardContent, setCardContent] = useState<any[] | null>(null);

    useEffect(() => {
        if (moreWaysToLearnComponent) {
            if (!props.fullRenderHTV) {
                const twoCards = moreWaysToLearnComponent?.cards.filter(
                    card => card.cardImageTextLabel != 'How-To Videos'
                );
                setCardContent(twoCards);
            } else {
                setCardContent(moreWaysToLearnComponent.cards);
            }
        }
    }, [moreWaysToLearnComponent, props.fullRenderHTV]);

    return (
        <>
            {cardContent &&
                cardContent.map(card => (
                    <article
                        className="more-ways-to-learn-card"
                        key={card.cardImageTextLabel}
                    >
                        <img
                            className="more-ways-to-learn-card-image"
                            src={`${process.env.REACT_APP_AEM_BASE_URL}${card?.cardImageSrc}`}
                            alt={`${card?.cardImageAltText}`}
                        />
                        <h2 className="more-ways-to-learn-card-text-label">
                            {card?.cardImageTextLabel}
                        </h2>
                        <Button
                            type={
                                card?.buttonType === 'standard'
                                    ? 'standard'
                                    : 'text'
                            }
                            label={card?.buttonLabel}
                            outlined={card?.buttonOutlined}
                            chevron={
                                card?.buttonChevron === 'left'
                                    ? 'left'
                                    : 'right'
                            }
                            href={`${props.baseRoot}${modifyCardCtaUrl(
                                card?.buttonHref || ''
                            )}`}
                            disabled={card?.buttonDisabled}
                            theme={
                                card?.buttonTheme === 'light' ? 'light' : 'dark'
                            }
                            preventDefault={card?.buttonPreventDefault}
                            noShadow={card?.buttonNoShadow}
                        />
                    </article>
                ))}
        </>
    );
};
